import { render, staticRenderFns } from "./fails-transactions.vue?vue&type=template&id=075e606a&scoped=true&"
import script from "./fails-transactions.vue?vue&type=script&lang=js&"
export * from "./fails-transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e606a",
  null
  
)

export default component.exports